import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardPageComponent } from './components/dashboard-page/dashboard-page.component';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path: ':name', component: DashboardPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard], component: AdminDashboardComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AllReformAreasRoutingModule { }
